export type GroupFilterType = {
  id: string;
  name: string;
  phone: string;
  email: string;
  address: string;
};

export type StructureAdvancedFilter = {
  key?: string;
  isDistributor?: boolean;
  isBranch?: boolean;
  isWhiteMark?: boolean;
  startDate?: string;
  endDate?: string;
  distributorId?: string;
  groupId?: string;
  companyId?: string;
  branchId?: string;
  role?: string;
  userId?: string;
};

export enum GroupLocalStorage {
  KEY = 'groupFilterKey',
  TYPE = 'groupFilterType',
  START_DATE = 'groupFilterStartDate',
  END_DATE = 'groupFilterEndDate',
  IS_WHITE_MARK = 'groupFilterIsWhiteMark',
  COMPANY_ID = 'groupFilterCompanyId',
  BRANCH_ID = 'groupFilterBranchId',
}
